import { RepeaterProp } from '@/types/cmsTypesGeneration/cmsStatic'

/**
 * A function that creates a new array of extracted values from value properties (this function was created because
 * of the values that are returned in certain cases from the backend)
 * @param fieldValues An array of objects for future remapping
 */
export const mapFromValue = (fieldValues: RepeaterProp<any>) =>
    fieldValues.map((fieldValueItem) => fieldValueItem.value)
